import SaveToWorkspace from '@patsnap-biz/save-to-workspace-v2'
import { VUE_APP_WORKSPACE_BASEURL, VUE_APP_WORKSPACE_DOMAIN_URL } from '@pharmsnap/pharmsnap-web/config'
import { getAxios } from '@pharmsnap/pharmsnap-web/service/service'
import { sharedCtx } from '@pharmsnap/shared/src/context'
import { ComponentInstance } from '@vue/composition-api'
import { AxiosInstance } from 'axios'
import { assign } from 'lodash'
import { Toast } from 'patsnap-biz'
import { IWorkspaceOriginParams, IWorkspaceServiceParams } from '../../type'

const { PaperService } = SaveToWorkspace

export default class SavePaperService extends PaperService {
  vm: ComponentInstance | undefined = undefined
  axiosInstance: AxiosInstance
  errorCodeI18nPrefix: string
  selectedIds: string[] = []
  searchParams: IWorkspaceServiceParams['searchParams']

  constructor(params: IWorkspaceServiceParams) {
    super()

    const { vm, selectedIds = [], searchParams, total = 0 } = params

    this.vm = vm
    this.axiosInstance = getAxios()
    this.baseUrl = `${VUE_APP_WORKSPACE_BASEURL}/workspace/web`
    this.workspaceProductDomain = VUE_APP_WORKSPACE_DOMAIN_URL
    this.errorCodeI18nPrefix = 'errorMessage'
    this.selectedIds = selectedIds
    this.searchParams = searchParams

    const selectCount = selectedIds.length
    const allCounts = selectCount > 0 ? selectCount : total
    this.rangeSelector = {
      ...this.rangeSelector,
      allCounts,
      maxInputLimit: allCounts,
    }
    this.enableRange = selectCount === 0

    this.init()
  }

  generateSubmitSaveToWorkspaceParams(params: IWorkspaceOriginParams) {
    sharedCtx.service.tracking.trackGeneral({
      event_code: 'SAVE_TO_WORKSPACE',
    })

    const commonParams = {
      data_type: this.type,
      folder_id: params.folderId,
      paper_count: this.selectedIds.length ? this.selectedIds.length : params.counts,
      source_type: 'SYNAPSE',
      space_id: params.workspaceId,
    }

    if (this.selectedIds.length) {
      return {
        ...commonParams,
        paper_ids: this.selectedIds,
      }
    }

    return {
      ...commonParams,
      range: true,
      range_params: {
        end: params.to,
        query_json: assign({}, this.searchParams, {
          offset: params.from - 1,
          limit: params.to - params.from + 1,
        }),
        start: params.from,
      },
    }
  }

  onToastError({ message }: { message: string }) {
    Toast({ message, type: 'error' })
  }

  onClose(success?: { template: string }) {
    if (success) {
      const { template } = success
      Toast.closeAll()
      Toast({
        type: 'success',
        message: template,
        dangerouslyUseHTMLString: true,
        duration: 5000,
        showClose: true,
      })
    }
    this.vm?.$emit('close')
  }
}
